import axios from 'axios';

const api = axios.create({
    baseURL: 'https://gu.dommusbeta.com.br/'
});

export default api;